import { useEffect } from 'react';

/**
 * Beacon the current path to /api/404-tracking on mount. Renders nothing.
 * Mount inside the NotFound page component so SPA-routed 404s reach D1.
 */
export default function NotFoundTracker() {
  useEffect(() => {
    try {
      const body = JSON.stringify({
        requestedPath: window.location.pathname,
        referrer: document.referrer || undefined,
      });
      if (navigator.sendBeacon) {
        const sent = navigator.sendBeacon(
          '/api/404-tracking',
          new Blob([body], { type: 'application/json' }),
        );
        if (sent) return;
      }
      fetch('/api/404-tracking', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    } catch {
      // Never throw.
    }
  }, []);
  return null;
}
